import {
  Autocomplete as MantineAutocomplete,
  type AutocompleteProps,
} from "@mantine/core";
import { useMemo } from "react";
import {
  type Control,
  type FieldValues,
  type Path,
  useController,
} from "react-hook-form";
import { normalizeAutocompleteData } from "src/utils/mantineComboboxData";

interface Props<T extends FieldValues> extends AutocompleteProps {
  name: Path<T>;
  control: Control<T>;
}

function Autocomplete<T extends FieldValues>({
  name,
  control,
  data,
  ...props
}: Props<T>) {
  const { field } = useController({
    name,
    control,
  });

  const normalizedData = useMemo(
    () => (data ? normalizeAutocompleteData(data) : data),
    [data],
  );

  return (
    <MantineAutocomplete {...props} {...field} data={normalizedData} />
  );
}

export default Autocomplete;
